import { defineRouting } from 'next-intl/routing';

export default defineRouting({
  defaultLocale: 'en',
  locales: ['en', 'de', 'ja'],

  pathnames: {
    '/career': {
      de: '/karriere',
      en: '/career',
      ja: '/career',
    },
    '/company': {
      de: '/unternehmen',
      en: '/company',
      ja: '/company',
    },
    '/imprint': {
      de: '/impressum',
      en: '/imprint',
      ja: '/imprint',
    },
    '/partners': {
      de: '/partner',
      en: '/partners',
      ja: '/partners',
    },
    '/press': {
      de: '/presse',
      en: '/press',
      ja: '/press',
    },
    '/press/[slug]': {
      de: '/presse/[slug]',
      en: '/press/[slug]',
      ja: '/press/[slug]',
    },
    '/privacy-policy': {
      de: '/datenschutzerklaerung',
      en: '/privacy-policy',
      ja: '/privacy-policy',
    },
  },
});
